export default __webpack_public_path__ + "static/media/img_shop-type03.60556a05.png";